import { produce } from 'immer';
import { SIGN_OUT } from 'app/store/users/types.js';
import { getCurrentProjectSlug } from 'app/routes';
import { extractError } from 'app/lib/error';
import { CREATE_VIEW_SUCCESS_TRANSFORMATION_STACK_CREATED } from 'app/store/__generated__/events';
import { SET_CURRENT_ENTITY } from 'app/store/projects/types.js';
import {
    CREATE_TRANSFORMATION,
    SELECT_OPERATION,
    START_OPERATION,
    CANCEL_OPERATION,
    ADD_OPERATION_TO_STACK,
    UPDATE_TRANSFORM_OPERATION,
    DELETE_TRANSFORM_OPERATION,
    OPEN_OPERATIONS_MENU,
    CLOSE_OPERATIONS_MENU,
    CLEAR_IDS
} from './types.js';

export const INITIAL_STATE = {
    creating: null,
    error: null,
    selectedIndex: null,
    keepOpen: false,
    isExecuting: false,
    isMenuOpen: false,
    menuAttachTo: null,
    inputNodeId: null,
    outputNodeIds: [],
    appendToStack: false
};

export const operationsReducer = produce((draft, action) => {
    switch (action.type) {
        case SELECT_OPERATION:
            draft.selectedIndex = action.payload.index;
            return;
        case START_OPERATION:
            draft.selectedIndex = null;
            draft.error = null;
            draft.creating = action.payload;
            draft.isMenuOpen = false;
            return;
        case SET_CURRENT_ENTITY:
            if (!draft.keepOpen) {
                draft.selectedIndex = null;
            }
            draft.creating = null;
            draft.error = null;
            draft.isExecuting = false;
            draft.isMenuOpen = false;
            draft.menuAttachTo = null;
            draft.inputNodeId = null;
            draft.outputNodeIds = [];
            draft.appendToStack = false;
            return;
        case CANCEL_OPERATION:
            draft.selectedIndex = null;
            draft.keepOpen = false;
            draft.creating = null;
            draft.error = null;
            draft.isExecuting = false;
            draft.isMenuOpen = false;
            draft.menuAttachTo = null;
            draft.inputNodeId = null;
            draft.outputNodeIds = [];
            draft.appendToStack = false;
            return;
        case ADD_OPERATION_TO_STACK.STARTED:
        case UPDATE_TRANSFORM_OPERATION.STARTED:
            draft.keepOpen = action.meta?.keepOpen;
            draft.isExecuting = true;
            draft.error = null;
            return;
        case CREATE_TRANSFORMATION.STARTED:
            if (action.meta?.keepOpen) {
                draft.keepOpen = true;
                draft.selectedIndex = 0;
            } else {
                draft.keepOpen = false;
            }
            draft.isExecuting = true;
            draft.error = null;
            return;
        case CREATE_TRANSFORMATION.FAILED:
        case ADD_OPERATION_TO_STACK.FAILED:
        case UPDATE_TRANSFORM_OPERATION.FAILED: {
            draft.isExecuting = false;
            draft.error = extractError(action.payload);
            return;
        }
        case DELETE_TRANSFORM_OPERATION.STARTED:
            draft.isExecuting = true;
            return;
        case DELETE_TRANSFORM_OPERATION.ENDED:
            draft.isExecuting = false;
            return;
        case CREATE_TRANSFORMATION.SUCCEEDED:
        case ADD_OPERATION_TO_STACK.SUCCEEDED:
        case UPDATE_TRANSFORM_OPERATION.SUCCEEDED:
        case CREATE_VIEW_SUCCESS_TRANSFORMATION_STACK_CREATED:
            if (getCurrentProjectSlug() === action.payload.viewRef?.spaceSlug) {
                draft.isExecuting = false;
                draft.creating = null;
                if (!action.meta?.keepOpen) {
                    draft.selectedIndex = null;
                }
            }
            return;
        case OPEN_OPERATIONS_MENU:
            draft.isMenuOpen = true;
            draft.menuAttachTo = action.payload.attachTo;
            draft.inputNodeId = action.payload.inputNodeId ?? null;
            draft.outputNodeIds = action.payload.outputNodeIds ?? [];
            draft.appendToStack = action.payload.appendToStack ?? false;
            draft.selectedIndex = null;
            draft.creating = null;
            draft.error = null;
            draft.isExecuting = false;
            return;
        case CLOSE_OPERATIONS_MENU:
            draft.isMenuOpen = false;
            break;
        case CLEAR_IDS:
            draft.inputNodeId = null;
            draft.outputNodeIds = [];
            break;
        case SIGN_OUT:
            return INITIAL_STATE;
        default:
    }
}, INITIAL_STATE);
